import { SVGProps } from 'react'

const UpArrowCorner = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='10' height='11' viewBox='0 0 10 11' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M6.49902 7.44504L8.44347 5.5006L6.49902 3.55615'
                stroke='#959699'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.22168 7.83382V7.05604C2.22168 6.64348 2.38557 6.24782 2.67729 5.9561C2.96901 5.66438 3.36468 5.50049 3.77724 5.50049H8.4439'
                stroke='#959699'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default UpArrowCorner
